module.exports = __webpack_public_path__ + "img/Karol-Trzeszczkowski.3bafe497.jpg";